import { component } from 'picoapp';

export default component(async (node) => {
  const resetBtns = node.querySelectorAll<HTMLButtonElement>('[data-reset-btn]');
  const clearAllBtn = node.querySelector<HTMLElement>('[data-clear-all-btn]');

  const init = () => {
    resetBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const { paramName, value } = btn.dataset;

        document.dispatchEvent(new CustomEvent('filterValue:remove', {
          detail: {
            paramName,
            value,
          },
        }));
      });
    });

    if (clearAllBtn && clearAllBtn.dataset.initialized !== 'true') {
      clearAllBtn.addEventListener('click', () => {
        document.dispatchEvent(new Event('filterValues:clearAll'));
      });
    }
  };

  init();
});
